import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    // {
    //     path: '/:type/:agent/:suffix',
    //     name: 'share',
    //     component: () => import( /* webpackChunkName: "Share" */ './views/Share.vue'),
    //   },
    // q 为买房  r 为租房
    {
      path: '/q/:agent/:suffix',
      name: 'sharebuy',
      component: () => import(/* webpackChunkName: "ShareBuyDetail" */ './views/BuyDetail.vue'),
    },
    {
      path: '/r/:agent/:suffix',
      name: 'sharerent',
      component: () => import(/* webpackChunkName: "ShareBuyDetail" */ './views/RentDetail.vue'),
    },
    {
      path: '/rent/detail/:id',
      name: 'rent',
      // route level code-splitting
      // this generates a separate chunk (rent.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "RentDetail" */ './views/RentDetail.vue'),
    },
    {
      path: '/sell/detail/:id',
      name: 'buy',
      component: () => import(/* webpackChunkName: "BuyDetail" */ './views/BuyDetail.vue'),
    },
    {
      path: '/rent/listing',
      name: 'rent',
      // route level code-splitting
      // this generates a separate chunk (rent.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "rent" */ './views/Rent.vue'),
    },
    {
      path: '/sell/listing',
      name: 'buy',
      component: () => import(/* webpackChunkName: "buy" */ './views/Buy.vue'),
    },
    {
      path: '/resources/buyer-services',
      name: 'buyer-services',
      component: () => import(/* webpackChunkName: "BuyerServices" */ './views/BuyerServices.vue'),
    },
    {
      path: '/our-agents/:page?',
      name: 'agents',
      component: () => import(/* webpackChunkName: "Agents" */ './views/Agents.vue'),
    },
    {
      path: '/agent/:username',
      name: 'agent-detail',
      component: () => import(/* webpackChunkName: "AgentDetail" */ './views/AgentDetail.vue'),
    },
    {
      path: '/article/:slug',
      name: 'article-detail',
      component: () => import(/* webpackChunkName: "NotFound" */ './views/ArticleDetail.vue'),
    },
    {
      path: '/covid-19',
      name: 'covid-19',
      component: () => import(/* webpackChunkName: "NotFound" */ './views/Covid.vue'),
    }, {
      path: '/jobs',
      name: 'jobs',
      component: () => import(/* webpackChunkName: "Jobs" */ './views/Jobs.vue'),
    },
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/404',
      name: 'notFound',
      component: () => import(/* webpackChunkName: "NotFound" */ './views/NotFound.vue'),
    },
  ],
})
